import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "schedule-section mt-2" }
const _hoisted_2 = { class: "section-card" }
const _hoisted_3 = {
  key: 0,
  class: "pro-header pa-4 pb-0"
}
const _hoisted_4 = { class: "pro-row" }
const _hoisted_5 = { class: "pro-avatar" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "pro-copy" }
const _hoisted_8 = { class: "pro-name" }
const _hoisted_9 = { class: "pro-meta" }
const _hoisted_10 = { class: "pro-meta" }
const _hoisted_11 = {
  key: 1,
  class: "summary-actions"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 2,
  class: "w-100"
}

import AssignProfessionalModal from "@/modules/vendor/components/appointments/AssignProfessionalModal.vue";
import NoProfessionalAssigned from "@/modules/vendor/components/appointments/NoProfessionalAssigned.vue";
import { computed } from "vue";
import { ref } from "vue";
import { formatPhoneNumber } from "@/shared/utils/phone";
import { useModalStore } from "@/shared/stores/modal";
import { fetchServiceProviders } from "@/modules/vendor/services/vendors.api";

type AppointmentAssignedProfessional = {
  vendor_id?: number | string | null;
  service_provider?: {
    avatar: string | null;
    name: string | null;
    email: string | null;
    phone_no: string | null;
  } | null;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'AppointmentAssignedProfessionalCard',
  props: {
    appointment: {}
  },
  emits: ["assigned", "message"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const appointment = computed(() => props.appointment);

const emit = __emit;

const modal = useModalStore();
const isLoadingProviders = ref(false);

const providerEmailHref = computed(() => {
  const email = props.appointment.service_provider?.email?.trim();
  return email ? `mailto:${email}` : "";
});

const providerPhoneHref = computed(() => {
  const phone = props.appointment.service_provider?.phone_no?.trim();
  return phone ? `tel:${phone}` : "";
});

function handleAssigned() {
  emit("assigned");
}

async function handleAssignProfessional() {
  const vendorId = props.appointment.vendor_id;
  isLoadingProviders.value = true;

  try {
    const providersResponse = vendorId ? await fetchServiceProviders(vendorId) : [];
    const providers = Array.isArray(providersResponse)
      ? providersResponse
      : Array.isArray((providersResponse as any)?.data)
        ? (providersResponse as any).data
        : [];

    modal.open(
      AssignProfessionalModal,
      {
        appointment: props.appointment,
        providers,
        onAssigned: () => {
          emit("assigned");
        },
      },
      { fullscreen: true, showHeader: false, title: "Assign Professional", scrollable: true },
    );
  } finally {
    isLoadingProviders.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "px-2" }, [
      _createElementVNode("p", { class: "schedule-section-title" }, "Assigned Professional")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (appointment.value?.service_provider)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_v_avatar, { size: "40" }, {
                  default: _withCtx(() => [
                    (appointment.value.service_provider.avatar)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: appointment.value.service_provider.avatar,
                          alt: "Service provider avatar",
                          loading: "lazy"
                        }, null, 8, _hoisted_6))
                      : (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          size: "18"
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("mdi-account-outline", -1)
                          ]))]),
                          _: 1
                        }))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(appointment.value.service_provider.name || "-"), 1),
                _createElementVNode("p", _hoisted_9, [
                  _createVNode(_component_v_icon, { size: "14" }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("mdi-email-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("span", null, _toDisplayString(appointment.value.service_provider.email || "-"), 1)
                ]),
                _createElementVNode("p", _hoisted_10, [
                  _createVNode(_component_v_icon, { size: "14" }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("mdi-phone-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("span", null, _toDisplayString(_unref(formatPhoneNumber)(appointment.value.service_provider.phone_no) || "-"), 1)
                ])
              ])
            ]),
            _createVNode(_component_v_btn, {
              icon: "",
              size: "small",
              variant: "tonal",
              class: "pro-edit-btn",
              color: "warning",
              "aria-label": "Edit assigned professional",
              loading: isLoadingProviders.value,
              disabled: isLoadingProviders.value,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleAssignProfessional()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("mdi-pencil-outline", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading", "disabled"])
          ]))
        : _createCommentVNode("", true),
      (appointment.value?.service_provider)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["summary-action", { 'summary-action--disabled': !providerEmailHref.value }]),
              disabled: !providerEmailHref.value,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('message')))
            }, [
              _createVNode(_component_v_icon, {
                size: "18",
                color: "deep-orange-darken-1"
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("mdi-message-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "Message", -1))
            ], 10, _hoisted_12),
            _createElementVNode("a", {
              class: _normalizeClass(["summary-action summary-action--split", { 'summary-action--disabled': !providerEmailHref.value }]),
              href: providerEmailHref.value || undefined
            }, [
              _createVNode(_component_v_icon, {
                size: "18",
                color: "deep-orange-darken-1"
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("mdi-email-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[9] || (_cache[9] = _createElementVNode("span", null, "Email", -1))
            ], 10, _hoisted_13),
            _createElementVNode("a", {
              class: _normalizeClass(["summary-action summary-action--split", { 'summary-action--disabled': !providerPhoneHref.value }]),
              href: providerPhoneHref.value || undefined
            }, [
              _createVNode(_component_v_icon, {
                size: "18",
                color: "deep-orange-darken-1"
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("mdi-phone-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[11] || (_cache[11] = _createElementVNode("span", null, "Call", -1))
            ], 10, _hoisted_14)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(NoProfessionalAssigned, {
              appointment: appointment.value,
              onAssigned: handleAssigned
            }, null, 8, ["appointment"])
          ]))
    ])
  ]))
}
}

})